import type { CoreLandingPage } from '../types'

/** Where a visitor on the route `path` goes instead, per the site's `core.landingPages`. */
export function landingPageTarget(landingPages: Record<string, CoreLandingPage>, path: string, isExisting: boolean): string | undefined {
    if (isExisting) return landingPages[path]?.lobby

    return Object.entries(landingPages).find(([, page]) => page.newVisitorsFromLobby && page.lobby === path)?.[0]
}
